<div class="main-content-text" [class.fade-out]="loading">
  <textarea
    [(ngModel)]="textInput"
    class="textInput"
    rows="8"
    placeholder="Paste your text here..."
  ></textarea>

  <div class="controls">
    <div class="control-row">
      <div class="control-group">
        <label for="expiry-select">Expiry Time</label>
        <select id="expiry-select" [(ngModel)]="expiryInMinutes">
          <option
            *ngFor="let expiryTime of expiryTimes"
            [value]="expiryTime.value"
          >
            {{ expiryTime.text }}
          </option>
        </select>
      </div>
      <div class="control-group">
        <app-custom-link
          #customLink
          (availabilityChange)="onSlugAvailabilityChange($event)"
          (slugChange)="onSlugChange($event)"
        ></app-custom-link>
      </div>
    </div>
    <app-additional-options
      [isExpanded]="isExpanded"
      (toggle)="toggleAdditionalOptions()"
    >
      <div class="security-option">
        <app-option-checkbox
          [checked]="isIpRestricted"
          (checkedChange)="isIpRestricted = $event"
          title="Share only within this network (Wi-Fi/VPN)"
        >
          <span suffix class="feature-badge">🔒 Secure</span>
        </app-option-checkbox>
      </div>

      <app-one-time-toggle
        [isOneTimeView]="isOneTimeView"
        (isOneTimeViewChange)="isOneTimeView = $event"
      ></app-one-time-toggle>

      <app-pin-toggle #pinToggle></app-pin-toggle>
    </app-additional-options>
    <app-bot-guard #botGuard></app-bot-guard>
    <button
      class="generate-button"
      [disabled]="!textInput.trim() || isSlugAvailable === false"
      (click)="generateLink(botGuard)"
    >
      Generate Link
    </button>
  </div>

  <app-loader-overlay
    *ngIf="loading"
    [message]="'Generating link...'"
  ></app-loader-overlay>
  <p class="footer-note">
    Note - We encrypt every message before storing it, ensuring complete
    privacy. No one can access your text, and it’s permanently removed once the
    expiry time is reached.
  </p>
</div>
<app-faq [items]="faqItems"></app-faq>

<div *ngIf="showDeleteSuccess" class="snackbar">
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
  >
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
    <polyline points="22 4 12 14.01 9 11.01"></polyline>
  </svg>
  <span>Link deleted successfully!</span>
</div>
